import React, { useEffect, useState } from "react";
import {
  BasePageLayout,
  BaseBox,
  BaseTypography,
  BaseButton,
} from "../../Common/UI/exports";
import { useNavigate } from "react-router-dom";
import { fetchOpenedReleaseHotfixes } from "../../APIs/AzureAPI";

function OpenedReleasesHotfixes() {
  const navigate = useNavigate();
  const [repos, setRepos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => setFilterText(e.target.value);

  const filteredRepositories = repos.filter((repo) =>
    repo.name.toLowerCase().includes(filterText.toLowerCase())
  );

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchOpenedReleaseHotfixes();
        setRepos(data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load opened releases/hotfixes.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <BasePageLayout sidebarItems={[]}>
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 2, fontWeight: 600 }}>
          Opened Release / Hotfixes
        </BaseTypography>

        <BaseBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mb: 1,
            flexGrow: 1,
          }}
        >
          <BaseBox sx={{ display: "flex", justifyContent: "flex-start" }}>
            <input
              type="text"
              placeholder="Filter repositories..."
              value={filterText}
              onChange={handleFilterChange}
              style={{
                padding: "6px 8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                minWidth: "250px",
              }}
            />
            <BaseTypography sx={{ fontSize: "0.9rem", ml: 2, alignSelf: "center" }}>
              Showing {filteredRepositories.length} of {repos.length}
            </BaseTypography>
          </BaseBox>

          <BaseBox sx={{ flexGrow: 1, overflowY: "auto", border: "1px solid #ccc" }}>
          {loading ? (
            <div style={{ padding: 16 }}>Loading...</div>
          ) : error ? (
            <div style={{ padding: 16, color: "red" }}>{error}</div>
          ) : repos.length === 0 ? (
            <div style={{ padding: 16 }}>No opened releases/hotfixes found.</div>
          ) : (
            <table className="repositories-table" style={{ width: "100%" }}>
              <thead style={{ backgroundColor: "#c4001d", color: "#fff" }}>
                <tr>
                  <th style={{ padding: "8px", color: "#040404ff" }}>Repo Name</th>
                  <th style={{ padding: "8px", color: "#040404ff" }}>Branches</th>
                  <th style={{ padding: "8px", color: "#040404ff" }}>Remote URL</th>
                </tr>
              </thead>
              <tbody>
                {filteredRepositories.length ? (
                  filteredRepositories.map((r) => (
                  <tr key={r.id}>
                    <td style={{ padding: "8px" }}>{r.name}</td>
                    <td
                      style={{
                        padding: "8px",
                        maxWidth: "420px",
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                      }}
                    >
                      {Array.isArray(r.branches) && r.branches.length > 0 ? (
                        <div>
                          {r.branches.map((b, i) => (
                            <div
                              key={i}
                              title={b}
                              style={{ marginBottom: 6, fontSize: "0.95rem" }}
                            >
                              {b}
                            </div>
                          ))}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td style={{ padding: "8px" }}>
                      <a href={r.remoteUrl} target="_blank" rel="noreferrer">
                        {r.remoteUrl}
                      </a>
                    </td>
                  </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                      No repositories match your filter.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
          </BaseBox>
        </BaseBox>

        <BaseBox sx={{ display: "flex", gap: 2, mt: 2 }}>
          <BaseButton onClick={() => navigate(-1)} color="secondary">
            Back
          </BaseButton>
        </BaseBox>
      </BaseBox>
    </BasePageLayout>
  );
}

export default OpenedReleasesHotfixes;
